import axios from 'axios';
import { normalize } from 'normalizr';
import { toProductModel } from '../../mappers/posts/toPostModel';
import { ProductItemModel } from '../posts/types';
import { productSchema } from './schema';
import { ProductDataModel } from './types';

export async function getProductsByUrl(url: string): Promise<ProductItemModel> {
    const response = await axios.post('/products', {
        url,
        data_source: 'manual',
    });

    return toProductModel(response.data.product);
}

export async function loadProducts(filters: {
    amount: number;
    catalogId?: string | null;
    next?: string;
}): Promise<{
    next: string;
    products: Array<ProductDataModel['id']>;
    records: {
        products: ProductDataModel[];
    };
}> {
    const { catalogId, ...params } = filters;

    const response = await axios.get(`/catalogs/feed/${catalogId}`, {
        params: {
            ...params,
        },
    });

    const normalized = normalize(
        {
            ...response.data,
            products: response.data.products.map(toProductModel),
        },
        {
            products: [productSchema],
        },
    );

    return {
        next: normalized.result.next,
        products: normalized.result.products,
        records: {
            products: Object.values(normalized.entities.products ?? {}),
        },
    };
}

export async function removeProduct(productId: string, catalogId: string): Promise<void> {
    await axios.patch('products', {
        product_id: productId,
        catalog_id: catalogId,
        enable_catalog: false,
    });
}
